import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-34b7d184"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Fechas del CSV:", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Parámetros a importar:", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_alert = _resolveComponent("el-alert")!

  return (_openBlock(), _createElementBlock("div", null, [
    (!_ctx.alert)
      ? (_openBlock(), _createBlock(_component_el_alert, {
          key: 0,
          type: "info",
          "show-icon": "",
          closable: false
        }, {
          default: _withCtx(() => [
            _createElementVNode("p", null, _toDisplayString(_ctx.$t("info.infoUpload")), 1),
            _hoisted_1,
            _hoisted_2,
            _createElementVNode("p", null, "Inicio: " + _toDisplayString(_ctx.formatDate(_ctx.startDate)), 1),
            _createElementVNode("p", null, "Fin: " + _toDisplayString(_ctx.formatDate(_ctx.endDate)), 1),
            _hoisted_3,
            _hoisted_4,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.headerParameter, (item) => {
              return (_openBlock(), _createBlock(_component_el_row, {
                key: item.id
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" - " + _toDisplayString(item.code), 1)
                ]),
                _: 2
              }, 1024))
            }), 128))
          ]),
          _: 1
        }))
      : (_openBlock(), _createBlock(_component_el_alert, {
          key: 1,
          title: _ctx.$t('warning.notSelectedParameter'),
          type: "warning",
          "show-icon": "",
          closable: false
        }, null, 8, ["title"]))
  ]))
}